import React, { useCallback, useState } from 'react';
import '../Common.scss';
import MainURL from '../../../MainURL';
import axios from 'axios';
import Footer from '../../../components/Footer';
import { useNavigate } from 'react-router-dom';
import { FaPen, FaFileAlt } from "react-icons/fa";
import { useDropzone } from 'react-dropzone'
import imageCompression from "browser-image-compression";
import Loading from '../../../components/Loading';
import { CiCircleMinus } from "react-icons/ci";
import { format } from "date-fns";
import { useRecoilState } from 'recoil';
import { recoilUserData } from '../../../RecoilStore';


const isImageFile = (file: File) => file.type.startsWith('image/');

export default function Post () {

  let navigate = useNavigate();

  const [userData] = useRecoilState(recoilUserData);

  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [inputFiles, setInputFiles] = useState<string[]>([]);
  const [attachFiles, setAttachFiles] = useState<File[]>([]);

  // 파일 첨부 함수 ----------------------------------------------
  const currentDate = new Date();
  const date = format(currentDate, 'yyMMddHHmmss');
  const [fileLoading, setFileLoading] = useState<boolean>(false);
  const onDrop = useCallback(async (acceptedFiles: File[]) => {
    try {
      setFileLoading(true);
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1000
      };
      const regexCopy = /[^a-zA-Z0-9!@#$%^&*()\-_=+\[\]{}|;:'",.<>]/g;
      const userIdCopy = userData?.userId.slice(0,5);

      const processedFiles = await Promise.all(
        acceptedFiles.map(async (file) => {
          let blob: Blob = file;
          if (isImageFile(file)) {
            blob = await imageCompression(file, options);
          }
          const regex = file.name.replace(regexCopy, '');
          const regexSlice = regex.slice(-15);
          return new File([blob], `${date}${userIdCopy}_${regexSlice}`, {
            type: file.type,
          });
        })
      );

      const fileNames = acceptedFiles.map((file) => {
        const regex = file.name.replace(regexCopy, '');
        const regexSlice = regex.slice(-15);
        return `${date}${userIdCopy}_${regexSlice}`;
      });

      setAttachFiles(processedFiles);
      setInputFiles(fileNames);
      setFileLoading(false);
    } catch (error) {
      console.error('파일 처리 중 오류 발생:', error);
      setFileLoading(false);
    }
  }, [date, userData?.userId]);
  const { getRootProps, getInputProps } = useDropzone({ onDrop }); 
 

  // 첨부 파일 삭제 ----------------------------------------------
  const deleteInputFile = async (Idx:number) => {
    setAttachFiles(prev => prev.filter((_, i) => i !== Idx));
    setInputFiles(prev => prev.filter((_, i) => i !== Idx));
  };

  // 글쓰기 등록 함수 ----------------------------------------------
  const datecopy = format(currentDate, "yyyy-MM-dd");
  const registerPost = async () => {
    const formData = new FormData();
    attachFiles.forEach((file) => {
      formData.append('img', file);
    });

    const getParams = {
      title : title,
      content: content,
      date : datecopy,
      userAccount : userData.userId,
      userNickName : userData.userName,
      postImage : JSON.stringify(inputFiles)
    }
    axios 
      .post(`${MainURL}/board/posts`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params: getParams,
      })
      .then((res) => {
        if (res.data) {
          navigate(-1);
        }
      })
      .catch(() => {
        console.log('실패함')
      })
  };


  return (
    <div className='board'>

      <div className="inner">

        <div className="subpage__main">
          <div className="subpage__main__title">
            <h3>글쓰기</h3>
            <div className='postBtnbox'
              style={{marginRight:'10px'}}
              onClick={()=>{navigate(-1);}}
            >
              <p>목록</p>
            </div>
          </div>
          
          <div className="subpage__main__content">

            <div className="userBox">
              <FaPen color='#334968' />
              <p>{userData.userName}</p>
            </div>
            <div className="addPostBox">
              <div style={{display:'flex', justifyContent:'space-between', alignItems:'end',}}>
                <p>제목</p>
                <h5 style={{fontSize:'12px'}}>* 최대 200자</h5>
              </div>
              <input value={title} className="inputdefault" type="text" 
                maxLength={200}
                onChange={(e) => {setTitle(e.target.value)}}/>
              <div style={{display:'flex', justifyContent:'space-between', alignItems:'end', marginTop:'20px'}}>
                <p>본문</p>
                <h5 style={{fontSize:'12px'}}>* 최대 2000자</h5>
              </div>
              <textarea 
                className="textarea textareapost"
                value={content}
                maxLength={2000}
                onChange={(e)=>{setContent(e.target.value)}}
              />
              <p style={{marginTop:'20px'}}>파일 첨부</p>
              <h5 style={{fontSize:'12px'}}>* 사진, PDF, 문서 등 파일 첨부 가능</h5>
            </div>
            <div className="imageInputBox">
              {
                fileLoading ?
                <div style={{width:'100%', height:'100%', position:'absolute'}}>
                  <Loading/>
                </div>
                :
                <div className='imageDropzoneCover'>
                  <div {...getRootProps()} className="imageDropzoneStyle" >
                    <input {...getInputProps()} />
                    {
                      attachFiles.length > 0 
                      ? <div className='imageplus'>+ 다시첨부하기</div>
                      : <div className='imageplus'>+ 파일첨부하기</div>
                    }
                  </div>
                </div>
              }
              {
                attachFiles.length > 0 &&
                attachFiles.map((item:any, index:any)=>{
                  return (
                    <div key={index} className='imagebox'>
                      {
                        isImageFile(item)
                        ? <img src={URL.createObjectURL(item)} alt={item.name} />
                        : <FaFileAlt size={40} color='#334968' style={{margin:'5px'}} />
                      }
                      <p>{item.name}</p>
                      <div onClick={()=>{deleteInputFile(index);}}>
                        <CiCircleMinus color='#FF0000' size={20}/>
                      </div>
                    </div>
                  )
                })
              }
            </div>
            

            <div style={{width:'100%', height:'2px', backgroundColor:'#EAEAEA', margin:'10px 0'}}></div>

            <div className="buttonbox">
              <div className="button"
              onClick={()=>{
                registerPost();
              }}
              >
                <p>작성 완료</p>
              </div>
            </div>

           </div>

           

          
        </div>
      </div>

      <Footer />
    </div>
  )
}
